import React, { useRef } from 'react'
import axios from 'axios'
import {
  ResumeAnalysisResponseType,
  ResumeAnalysisServiceResponse,
} from '@iteach/types'
import { Page } from '../components/Page'

const ResumeAnalysisWidget = ({
  analysis,
}: {
  analysis: ResumeAnalysisResponseType
}) => {
  return (
    <div>
      <h2>Resume Analysis</h2>
      <div>
        <ul>
          <li>Name: {analysis.name}</li>
          <li>Email: {analysis.email}</li>
          <li>LinkedIn: {analysis.linkedin}</li>
          <li>Phone: {analysis.phone}</li>
          <li>Website: {analysis.website}</li>
          <li>Github: {analysis.github}</li>

          <li>Years Experience: {analysis.yearsOfExperienceTotal}</li>
          <li>Languages: {analysis.languages.join(', ')}</li>
          <li>Primary Focus: {analysis.primaryFocus}</li>
          <li>Rating: {analysis.rating}</li>
          <li>Rating Reason: {analysis.ratingReason}</li>
        </ul>
      </div>
    </div>
  )
}

const TextAnalysisWidget = ({ text }: { text: string }) => {
  const [textAnalysis, setTextAnalysis] =
    React.useState<ResumeAnalysisResponseType | null>(null)
  const [loading, setLoading] = React.useState<boolean>(false)

  const analyzeText = async () => {
    setLoading(true)
    try {
      console.log('Starting analysis call...')
      const response = await axios.post(
        'http://localhost:2138/api/v1/resumes/analyze-resume-no-db',
        {
          text: text,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'test',
          },
        },
      )

      if (!response.data) {
        throw new Error('No data returned')
      }
      const data = response.data as ResumeAnalysisServiceResponse
      if (!data.success) {
        throw new Error('Service call failed')
      }

      //////////
      setLoading(false)
      setTextAnalysis(data.analysisResult)
      console.log('Analyze text: ', data)
    } catch (e: any) {
      console.log('Error analyzing text: ', e)
      setLoading(false)
      setTextAnalysis(null)
    }
  }

  if (!text) {
    return (
      <div>
        <h2>Resume Text</h2>
        <div>No text yet!</div>
      </div>
    )
  }

  return (
    <div>
      <h2>Resume Text</h2>
      <textarea
        style={{ height: '10rem', width: '100%' }}
        value={text}
      ></textarea>
      <button onClick={() => analyzeText()} disabled={loading}>
        Analyze text
      </button>
      {textAnalysis && (
        <ResumeAnalysisWidget analysis={textAnalysis}></ResumeAnalysisWidget>
      )}
    </div>
  )
}

const DemoPDFToText = () => {
  // Reference for the file input
  const fileInput = useRef(null)
  const [textParsed, setTextParsed] = React.useState<string | null>(null)

  const handleFileChange = async (e: any) => {
    const file = e.target.files[0]
    if (file) {
      // Create a FileReader to read the PDF binary data
      const reader = new FileReader()
      reader.onload = async (e) => {
        // Convert the ArrayBuffer to a PDF.js-friendly format
        const typedArray = new Uint8Array(e.target!.result as ArrayBuffer)
        // @ts-ignore - Type 'ArrayBuffer' is not assignable to type 'string'.
        const pdf = await pdfjsLib.getDocument(typedArray).promise

        let structuredText: string[] = []

        // Limiting the pages processed to 3 or less
        const numPages = Math.min(3, pdf.numPages)

        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          const page = await pdf.getPage(pageNum)
          const textContent = await page.getTextContent()

          let lastY: number | null = null

          // Page indicator
          structuredText.push(`\n\n==== Page ${pageNum} ====\n\n`)

          for (const item of textContent.items) {
            const { transform, str } = item
            const [, , , , x, y] = transform

            if (lastY !== null && Math.abs(y - lastY) > 2) {
              structuredText.push('\n')
            }

            if (lastY !== null && Math.abs(y - lastY) > 10) {
              structuredText.push('\n\n')
            }

            structuredText.push(str)
            lastY = y
          }
        }

        const finalText = structuredText.join(' ')
        console.log('Final text', finalText)
        setTextParsed(finalText)
      }

      reader.readAsArrayBuffer(file)
    }
  }

  return (
    <div>
      <div>
        <label>PDF Text Extractor</label>
        <input
          type="file"
          ref={fileInput}
          onChange={handleFileChange}
          accept=".pdf"
        />
      </div>
      <div>{textParsed && <TextAnalysisWidget text={textParsed} />}</div>
    </div>
  )
}

export const DemoLocalPDFToText2 = () => {
  return (
    <Page>
      <div>
        <h1>Test pdf upload</h1>

        <DemoPDFToText />
      </div>
    </Page>
  )
}
